import enPortfolio from '../data/portfolio/en.json';
import zhPortfolio from '../data/portfolio/zh.json';

const portfolioData = {
  en: enPortfolio,
  zh: zhPortfolio
};

export const getPortfolioItems = (language = 'en') => {
  return portfolioData[language] || portfolioData.en;
};

export const getPortfolioItemById = (id, language = 'en') => {
  const data = getPortfolioItems(language);
  return data.portfolio.find(item => item.id === id) || null;
};

export const getEnabledPortfolioItems = (language = 'en') => {
  const data = getPortfolioItems(language);
  return data.portfolio
    .filter(item => item.enabled !== false)
    .sort((a, b) => (a.order || 0) - (b.order || 0));
};

const portfolioService = {
  getPortfolioItems,
  getPortfolioItemById,
  getEnabledPortfolioItems
};

export default portfolioService;
